
import { ListDataSource } from "@/data/List/ListDataSource";
import { ComponentLinkDataSource } from "@/data/List/ComponentLinkDataSource";
import { Vue, Component, Watch } from "vue-property-decorator";
import ObjectDataTable from "@/components/helpers/object-data-table.vue";
import {
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiMinus,
  mdiPen,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiTrashCan,
} from "@mdi/js";
import editor from "./editor";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";

@Component({
  mixins: [editor],
  components: { ObjectDataTable },
})
export default class ProductLinkInlineEditor extends Vue {
  dataSource!: ObjectDataSource;
  searchTimer: any = null;
  dialog: boolean = false;
  searchText: string = "";
  filterText: string = "";
  loaded: boolean = false;
  icons: any = {
    plus: mdiPlus,
    minus: mdiMinus,
    pen: mdiPen,
    trash: mdiTrashCan,
    search: mdiMagnify,
    dotsVertical: mdiDotsVertical,
    circlePlus: mdiPlusCircleOutline,
    folderOpen: mdiFolderOpen,
    folder: mdiFolder,
  };

  headers: any[] = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Подпись",
      value: "caption",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  videoDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 100 },
    className: "video",
  });

  linkedVideoDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 100 },
    className: "video",
  });

  componentLinkDataSource: ComponentLinkDataSource =
    new ComponentLinkDataSource();
  $message: any;

  updateVideos() {
    let sourceItems = [...this.videoDataSource.items];
    console.log(this.dataSource.model);

    for (const commodity of sourceItems) {
      const cb = (c: any) => c.id == commodity.id;

      const exists = this.dataSource.model?.linkedVideos.some(cb);
      if (exists) {
        const index = this.videoDataSource.items.findIndex(cb);
        this.videoDataSource.items.splice(index, 1);
        // this.linkedVideoDataSource.items.push(commodity);
      }
    }
    this.linkedVideoDataSource.items = this.dataSource.model?.linkedVideos;
  }

  filterLinkedVideo() {
    this.updateVideos();
    if (!this.filterText) return;
    const re = new RegExp(this.filterText, "gi");
    this.linkedVideoDataSource.items = this.linkedVideoDataSource.items.filter(
      (c: any) => c.caption.match(re),
    );
  }

  async created() {
    await this.videoDataSource.get();
    this.linkedVideoDataSource.metadata = this.videoDataSource.metadata;
    this.linkedVideoDataSource.total =
      this.dataSource.model?.linkedVideos?.length;
    this.updateVideos();
    this.loaded = true;
  }

  async add(item: any) {
    await this.componentLinkDataSource.add({
      componentId: item.id,
      componentClassId: item.classId,
      linkedComponentId: this.dataSource.id,
      linkedComponentClassId: this.dataSource.model?.classId,
    });

    await this.dataSource.get();
    this.updateVideos();
    this.linkedVideoDataSource.total = this.linkedVideoDataSource.items.length;
    this.$message("Успешно добавлено");
  }

  async remove(item: any) {
    await this.componentLinkDataSource.remove({
      componentId: item.id,
      componentClassId: item.classId,
      linkedComponentId: this.dataSource.id,
      linkedComponentClassId: this.dataSource.model?.classId,
    });
    const index = this.linkedVideoDataSource.items.findIndex(
      (c: any) => c.id === item.id,
    );
    if (index === -1) throw new Error("не найден");
    this.linkedVideoDataSource.items.splice(index, 1);
    this.videoDataSource.items.push(item);
    this.linkedVideoDataSource.total = this.linkedVideoDataSource.items.length;

    this.$message("Успешно удалено");
  }

  @Watch("searchText")
  debounceSearch(value: string) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(async () => {
      this.videoDataSource.config.filter = JSON.stringify([
        {
          fieldName: "searchText",
          fieldValue: value,
        },
      ]);
      await this.videoDataSource.get();
      this.updateVideos();
    }, 1000);
  }
}
